import { cross } from "./internal";
// triangulates a monotone mountain based on `edge`, adding resulting triangles to the `triangles` array
export function triangulateMountain(edge, triangles) {
    const a = edge.p;
    const b = edge.q;
    const poly = edge.poly;
    let p = poly.first.next;
    if (poly.length < 3) {
        return;
    }
    else if (poly.length === 3) {
        triangles.push([a, p.point, b]);
        return;
    }
    const convexPoints = [], positive = cross(p.point, b, a) > 0;
    while (p !== poly.last) {
        addEar(convexPoints, p, poly, positive);
        p = p.next;
    }
    while (convexPoints.length) {
        const ear = convexPoints.shift(), prev = ear.prev, next = ear.next;
        triangles.push([prev.point, ear.point, next.point]);
        poly.remove(ear);
        addEar(convexPoints, prev, poly, positive);
        addEar(convexPoints, next, poly, positive);
    }
}
export function addEar(points, p, poly, positive) {
    if (!p.ear && p !== poly.first && p !== poly.last && isConvex(p, positive)) {
        p.ear = true;
        points.push(p);
    }
}
export function isConvex(p, positive) {
    return positive === cross(p.next.point, p.prev.point, p.point) > 0;
}
//# sourceMappingURL=mountain.js.map